import { api } from '../../../api';

export const contactUsAPI = payload => {
  return api.post('/v1/contact_us', payload);
};
